<div [formGroup]="form" class="schedules-form">
  <mat-checkbox
    [formControl]="form.controls.collectiveSchedules"
    (change)="onHorairesCollectifsChange($event.checked)"
    [matTooltip]="collectiveSchedulesMatTooltip"
  >
    Horaires collectifs
  </mat-checkbox>
  <table class="days">
    @for (daySchedule of form.controls.schedules.controls; track $index; let dayIndex = $index) {
      <tr class="day">
        <th class="header">
          <div>
            <span class="label">{{ daySchedule.controls.day.value | dayOfWeekLabel }}</span>
            @let dayChanged = dayChange(dayIndex);
            <span [class.changed]="!!dayChanged" [matTooltip]="dayChanged">
              {{ daySchedule.controls.slots.value | slotsDuration }}</span
            >
          </div>
          @if (!readOnly()) {
            <div class="actions">
              <mat-icon
                (click)="setWeekSlots($index)"
                matTooltip="Utiliser les mêmes horaires pour les 7 jours"
                >format_line_spacing</mat-icon
              >
              <mat-icon
                (click)="clearDaySlots(daySchedule.controls.day.value)"
                matTooltip="Supprimer les horaires de ce jour"
                >backspace</mat-icon
              >
            </div>
          }
        </th>
        @for (slot of daySchedule.controls.slots.controls; track $index) {
          @let slotChanged = slotChange(dayIndex, $index);
          <td [class.changed]="!!slotChanged" [matTooltip]="slotChanged ?? slotsMatTooltip">
            <app-slot-form [formGroup]="slot"></app-slot-form>
          </td>
        }

        @if (!readOnly()) {
          <div class="actions">
            @if ($index === 0) {
              <mat-icon (click)="addSlot()" matTooltip="Ajouter un créneau">add_box</mat-icon>
              @if (daySchedule.controls.slots.controls.length > 1) {
                <button
                  matIconButton
                  color="warn"
                  (click)="removeLastSlots()"
                  matTooltip="Supprimer le dernier créneau"
                >
                  <mat-icon>delete_sweep</mat-icon>
                </button>
              }
            }
          </div>
        }
      </tr>
      @if (daySchedule.hasError('overlap')) {
        <tr class="day">
          <th class="header"></th>
          <td [attr.colspan]="daySchedule.controls.slots.length" class="text-right">
            <mat-error>Certains créneaux se chevauchent</mat-error>
          </td>
        </tr>
      }
      @if (form.controls.schedules.hasError('minTimeBetweenDay')) {
        @let error = form.controls.schedules.getError('minTimeBetweenDay');
        @if (error.includes(daySchedule.controls.day.value)) {
          <tr class="day">
            <th class="header"></th>
            <td [attr.colspan]="daySchedule.controls.slots.length" class="text-right">
              <mat-error>Le temps de repos minimum n'est pas respecté</mat-error>
            </td>
          </tr>
        }
      }
    }
  </table>
  @if (form.controls.schedules.hasError('maxTotalHours')) {
    @let error = form.controls.schedules.getError('maxTotalHours');
    <mat-error>
      {{ error.actual }} heures par semaine dépasse les {{ error.max }}h maximum autorisées.
    </mat-error>
  }
</div>
